

import {Component, Vue, Watch} from "vue-property-decorator";
import {ProgramPaths} from "@/enum/ProgramPaths";
import HesapBilgileri from "@/views/ofispro/HesapBilgileriView.vue";
import {store} from "@/store";
import axios from "axios";

@Component({
  computed: {
    store() {
      return store
    },
    uyapAvukatBakiye(){
      return this.$store.getters.avukatBakiye;
    },
    uyapSorguBakiye(){
      return this.$store.getters.sorguBakiye;
    }
  },
  components: {HesapBilgileri}
})
export default class UserInfoCard extends Vue {
  menu: Boolean = false;
  bakiyeLoading = false;
  userData = JSON.parse(sessionStorage.user);

  get avukatBilgileri(){
    return this.$store.getters.avukatBilgileri;
  }

  /**
   * tenantList aynı tenant_id'yi birden fazla içerebiliyor (kullanıcının aynı tenant'ta
   * birden çok lisans/rolü) → v-for :key duplicate uyarısı. Burada tenant_id'ye göre
   * tekilleştirilir; ilk kayıt korunur.
   */
  get uniqueTenantList(): any[] {
    const list = this.$store.state.tenantList || [];
    const seen = new Set();
    const result: any[] = [];
    for (const t of list) {
      if (t && !seen.has(t.tenant_id)) {
        seen.add(t.tenant_id);
        result.push(t);
      }
    }
    return result;
  }

  @Watch('menu')
  async onMenuChange(isOpen: boolean) {
    if (isOpen && !this.bakiyeLoading) {
      if (!this.$store.getters.isImzaConnected || !this.$store.getters.isUyapConnected) {
        return;
      }
      try {
        this.bakiyeLoading = true;
        const res = await this.$uyap.AvukatBakiyeSorgula().run({});
        this.$store.commit('setUyapAvukatBakiye', res.value);
        const sorguBakiyeRes = await this.$uyap.SorguBakiyesi().run({});
        this.$store.commit('setUyapSorguBakiye', sorguBakiyeRes.sorguBakiye);
      } catch {
        /* sessizce devam et */
      } finally {
        this.bakiyeLoading = false;
      }
    }
  }

  get imzaSahibiAdi(){
    return `${this.avukatBilgileri?.adi} ${this.avukatBilgileri?.soyadi}`.trim();
  }

  hesapBilgileri() {
    this.$router.push(ProgramPaths.ofispro + '/hesap-bilgileri/');
  }

  barokartBakiyeYukle() {
    window.open('https://barokart.com.tr/TL_Yukle.aspx', '_blank');
  }

  async switchTenant(item: any) {
    this.$toast.info("Oturum değişikliği yapılıyor");
    this.$store.commit("setTenantId", item.tenant_id);
    let userRes = await this.$http.get("/api/v1/ben")
    this.$store.commit('setUser', userRes);
    location.reload();
  }

  get userInitials(): string {
    if (this.userData && this.userData.first_name && this.userData.last_name) {
      return (this.userData.first_name[0] + this.userData.last_name[0]).toUpperCase();
    }
    return '';
  }

  async created() {
    //buna artik gerek yok zaten atiyor.
    //await this.$store.dispatch("getTenantList");
  }

}
